import React from 'react';
import styles from './HighlightClickableText.module.css';
import PropTypes from 'prop-types';

const HighlightClickableText = ({ text, highlightText, url }) => {
  const parts = text.split(highlightText);
  const goToPrivacyPolicyPage = () => {
    window.open(url, '_blank');
  };

  return (
    <div>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <a href={url} target="_blank" rel="noopener noreferrer" className={styles.highlight} onClick={goToPrivacyPolicyPage}>
              {highlightText}
            </a>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

HighlightClickableText.propTypes = {
  text: PropTypes.string,
  highlightText: PropTypes.string,
  url: PropTypes.string
};

export default HighlightClickableText;
